import { WaveCloudAPI, WAVE_APP_ID } from "@vida/wave-core";
import { createWaveApiConfig, trackActivity } from "./waveSession";
import { searchWaveDocuments } from "./waveRag";
import { buildContextFromChunks, pollAIJob } from "./waveAiJobHelpers";
import { WAVE_AGENT_MODEL_ID } from "./waveAgentModel";

/** Query wave documents via RAG + Bedrock Converse job. */
export async function runWaveDocQuery(
  waveId: string,
  question: string,
): Promise<string> {
  const trimmed = question.trim();
  if (!trimmed) throw new Error("Domanda vuota.");

  const chunks = await searchWaveDocuments(waveId, trimmed, 8);
  const context = buildContextFromChunks(chunks);

  const cfg = createWaveApiConfig();
  const params = {
    bedrock: {
      systemText:
        "Sei l'assistente Wave. Rispondi in italiano usando SOLO le informazioni nei estratti " +
        "dei documenti allegati al thread. Se la risposta non è nei documenti, dillo chiaramente. " +
        "Cita il nome file quando rilevante.",
      userText:
        `DOMANDA:\n${trimmed}\n\n` +
        `ESTRATTI DOCUMENTI (thread ${waveId}):\n${context}`,
      maxTokens: 4096,
    },
    waveId,
  };

  const result = await WaveCloudAPI.submitAIJob(cfg, {
    kind: "BEDROCK_CONVERSE",
    provider: "BEDROCK",
    prompt: trimmed,
    paramsJson: JSON.stringify(params),
    inputAssetKeys: [],
    appId: WAVE_APP_ID,
    modelId: WAVE_AGENT_MODEL_ID,
    feature: "wave.agent.rag_query",
  });

  trackActivity("Documenti Wave", `Query RAG (job ${result.jobId.slice(0, 8)}…)`);
  return pollAIJob(result.jobId);
}

/** Parse `@documenti:` directive from command bar. */
export function parseDocumentQueryDirective(text: string): string | null {
  const match = text.match(/@documenti:\s*(.+)/i);
  return match?.[1]?.trim() || null;
}

export async function runWaveDocQueryFromDirective(
  waveId: string,
  commandText: string,
): Promise<string | null> {
  const q = parseDocumentQueryDirective(commandText);
  if (!q) return null;
  return runWaveDocQuery(waveId, q);
}
